// Inventaire du tour mis de côté (« Enregistrer pour plus tard ») : l'état de la saisie est rangé sur le serveur en
// statut « pending » (inventories/save-draft), hors de la liste des inventaires, puis relu pour reprendre là où la
// saisie s'est arrêtée. Les comptages, thèmes, commentaires et photos y sont repérés par le nom du thème et de
// l'objet (les identifiants t0, t0-o1… ne tiennent qu'à l'ordre du modèle), comme restoredCounts.

import { photoUrl } from './fieldApi'

const GENERAL = null

function themeName(themes, themeId)
{
	const theme = themes.find(item => item.id === themeId)
	return theme ? theme.name : GENERAL
}

function themeId(themes, name)
{
	const theme = name === GENERAL ? null : themes.find(item => item.name === name)
	return theme ? theme.id : null
}

// notes.photos et les photos des problèmes signalés doivent déjà être envoyées (file_id), voir uploadDraftFiles
export function draftState({ themes, counts, doneThemes, notes, interventions, user })
{
	const answers = []
	themes.forEach(theme => {
		theme.objects.forEach(object => {
			if (counts[object.id] !== undefined)
				answers.push({ theme: theme.name, name: object.name, count: counts[object.id] })
		})
	})
	return {
		version: 1,
		user_name: user ? ((user.firstname || '') + ' ' + (user.lastname || '')).trim() : '',
		counts: answers,
		done_themes: themes.filter(theme => doneThemes[theme.id]).map(theme => theme.name),
		comments: notes.comments.map(comment => ({
			id: comment.id,
			theme: themeName(themes, comment.themeId),
			comment: comment.comment,
			user: comment.commentUser,
			time: comment.commentTime,
			after: !!comment.after,
			deleted_time: comment.commentDeletedTime || null
		})),
		photos: notes.photos.filter(photo => !!photo.file_id).map(photo => ({
			id: photo.id,
			theme: themeName(themes, photo.themeId),
			file_id: photo.file_id,
			fingerprint: photo.fingerprint || null,
			description: photo.description || '',
			user: photo.user,
			time: photo.time,
			after: !!photo.after
		})),
		interventions: interventions.map(item => ({ kind: item.kind, doc: item.doc, photos: (item.photos || []).filter(photo => !!photo.file_id).map(photo => ({ file_id: photo.file_id })) }))
	}
}

// La saisie à reprendre : { counts, doneThemes, notes, interventions } dans la forme de l'écran
export function restoreDraft(themes, state)
{
	const counts = {}
	const byName = {}
	;(state.counts || []).forEach(item => {
		byName[item.theme + '|' + item.name] = item.count
	})
	themes.forEach(theme => {
		theme.objects.forEach(object => {
			const count = byName[theme.name + '|' + object.name]
			if (count !== undefined)
				counts[object.id] = count
		})
	})
	const doneThemes = {}
	themes.forEach(theme => {
		if ((state.done_themes || []).indexOf(theme.name) !== -1)
			doneThemes[theme.id] = true
	})
	const notes = {
		comments: (state.comments || []).map(item => ({ id: item.id, themeId: themeId(themes, item.theme), comment: item.comment, commentUser: item.user, commentTime: item.time, after: !!item.after, commentDeletedTime: item.deleted_time || undefined })),
		photos: (state.photos || []).map(item => ({ id: item.id, themeId: themeId(themes, item.theme), file_id: item.file_id, url: photoUrl(item.file_id, 720), thumb: photoUrl(item.file_id, 360), fingerprint: item.fingerprint, description: item.description, user: item.user, time: item.time, after: !!item.after }))
	}
	const interventions = (state.interventions || []).map((item, index) => ({ id: 'pending-draft-' + index, kind: item.kind, doc: item.doc, photos: item.photos || [], photoCount: (item.photos || []).length, during: true, pending: true }))
	return { counts, doneThemes, notes, interventions }
}
